//// Vendors ////
import AOS from 'aos';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Glide from '@glidejs/glide';
import focus from '@alpinejs/focus';

//// SITE functions ////
import { menuMain } from './components/_menu';
import { siteheaderScroll } from './components/_site-header-scroll';
import { bannerHome } from './components/_banner-home';
import { bannerAbout } from './components/_banner-about';
import { bannerCareers } from './components/_banner-careers';
import { bannerConnected } from './components/_banner-connected';
import { bannerListings } from './components/_banner-listings';
import { bannerLogo } from './components/_banner-logo';
import { initHeroStatements, initHeroShapes, initHeroScroll } from './components/_banner-prop';
import { flxValues } from './components/_flx-values';
import { testimonialFade } from './components/_testimonial-fade';
import { footer } from './components/_footer';
import { speakers } from './components/_speakers';
//import { team } from './components/_team';
import tabsComponent from './components/_flxTabs';

//// FLX ////
import { flxStats } from './components/_flx-stats';
import { initAnchorScroll } from './components/_anchorScroll';

//// PA ////
import { paHeroLanding } from './components/plan-apps/_pa-hero-landing';
import { paFlxIntro } from './components/plan-apps/_pa-flx-intro';
import { paPipeAnim } from './components/plan-apps/_pa-pipes';
import { paBsPipeAnim } from './components/plan-apps/_pa-bs-pipes';
import { paModApps } from './components/plan-apps/_pa-mod-apps';

// DOM ready first
document.addEventListener(
    'DOMContentLoaded',
    function () {
        // Site header
        siteheaderScroll();

        // Alpine globals
        window.Alpine = Alpine;
        Alpine.plugin(collapse);
        Alpine.plugin(focus);
        Alpine.plugin(intersect);
        window.Glide = Glide;

        Alpine.data('tabsComponent', tabsComponent);
        Alpine.data('paModApps', paModApps);

        Alpine.start();
        window.AOS = AOS;

        // menu
        menuMain();

        // Banners
        bannerHome();
        bannerAbout();
        bannerCareers();
        bannerConnected();
        bannerListings();
        bannerLogo();
        initHeroStatements();
        initHeroShapes();
        initHeroScroll();

        initAnchorScroll(80);

        // Footer
        footer();

        // FLX
        flxValues();
        flxStats();
        testimonialFade();
        speakers();

        // Team
        //team();

        // PA
        paHeroLanding();
        paFlxIntro();
        paPipeAnim();
        paBsPipeAnim();

        // AOS
        AOS.init({
            duration: 800,
            offset: 32,
            startEvent: 'load'
        });
    },
    false
);

jQuery(document).on('sf:ajaxfinish', '.searchandfilter', function () {
    AOS.refresh();
});
